import { render, staticRenderFns } from "./EditVideoPage.vue?vue&type=template&id=96617424&"
import script from "./EditVideoPage.vue?vue&type=script&lang=js&"
export * from "./EditVideoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports